<template>
  <div class="item-source-block" @click="modal('ItemSourceDetailModal', orderItem)" :class="{
    error: itemSource.qsError > 0,
    enough: itemSource.qsTotal > 0 && (orderItem.quantity - orderItem.quantityReturn) <= itemSource.qsTotal,
    complete: itemSource.qsLaded > 0 && itemSource.qsTotal <= itemSource.qsLaded
  }"
  >
    <div class="total">货源{{ itemSource.qsTotal }}</div>
    <div v-if="itemSource.qsUnDo" class="undo">待办{{ itemSource.qsUnDo }}</div>
    <div v-if="itemSource.qsPurchasing" class="purchasing">在途{{ itemSource.qsPurchasing }}</div>
    <div v-if="itemSource.qsLaded" class="laded">到货{{ itemSource.qsLaded }}</div>
    <div v-if="itemSource.qsClaiming" class="claiming">索赔{{ itemSource.qsClaiming }}</div>
  </div>
</template>
<script>
export default {
  props: {
    orderItem: {
      type: Object,
      default () {
        return {
          id: undefined,
          quantity: 0,
          quantityReturn: 0,
          quantityDelivered: 0,
          itemSources: []
        }
      }
    }
  },
  computed: {
    itemSource () {
      const sources = this.orderItem.itemSources || []
      const qsTotal = sources.filter(t => t.state > 0).reduce((p, c) => p + c.quantity, 0)
      const qsUnDo = sources.filter(t => t.state === 1 || t.state === 3).reduce((p, c) => p + c.quantity, 0)
      const qsPurchasing = sources.filter(t => t.state === 2 || t.state === 4).reduce((p, c) => p + c.quantity, 0)
      const qsLaded = sources.filter(t => t.state === 5).reduce((p, c) => p + c.quantity, 0)
      const qsClaiming = sources.filter(t => t.state === 6).reduce((p, c) => p + c.quantity, 0)
      const qsError = sources.filter(t => t.state === -1 &&
      ((t.sourceType === 2 && t.timeForArrivalActual !== null) ||
      ((t.sourceType === 4 || t.sourceType === 3) && t.timeForLadingActual !== null))).reduce((p, c) => p + c.quantity, 0)
      return {
        qsTotal,
        qsUnDo,
        qsPurchasing,
        qsLaded,
        qsClaiming,
        qsError
      }
    }
  }
}
</script>

<style lang="stylus">
.item-source-block
  display inline-flex
  flex-direction row
  border 1px solid #dbdbdb
  cursor pointer
  >div
    text-align center
    line-height 1
    padding 2px 4px
    flex-grow 0
    font-size 13px
  >.total
    color #000
    background #f2f2f2
  >.undo
    color #000
  >.purchasing
    color #f59a23
  >.laded
    color #70b603
  >.claiming
    color #8400ff
  &.enough
    border-color #f59a23
    >.total
      color #fff
      background #f59a23
  &.complete
    border-color #70b603
    >.total
      color #fff
      background #70b603
  &.error
    border-color #d9001b
    >.total
      color #fff
      background #d9001b
</style>
